'use client'

import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react'
import React, { useEffect, useState } from 'react'
import { Button } from './button'

type Props = {
  title?: React.ReactNode | string
  content: React.ReactNode | string
  open: boolean
  onConfirm: () => void
  onCancel: () => void
} & React.ComponentPropsWithoutRef<'div'>

export function Confirm({ title, content, open, onConfirm, onCancel }: Props) {
  const [isOpen, setIsOpen] = useState(open)

  useEffect(() => {
    setIsOpen(open)
  }, [open])

  function handleConfirm() {
    setIsOpen(false)
    onConfirm()
  }

  function handleCancel() {
    setIsOpen(false)
    onCancel()
  }

  return (
    <Dialog open={isOpen} onClose={setIsOpen} className='relative z-40 overflow-y-scroll'>
      <DialogBackdrop transition className='dialog-backdrop' />
      <div className='fixed inset-0 z-50 w-screen'>
        <div className='flex min-h-full items-center justify-center px-4 sm:p-0'>
          <DialogPanel transition className='dialog-panel'>
            <DialogTitle className='dialog-title'>
              {title}
            </DialogTitle>
            <div className='text-zinc-700 dark:text-zinc-300'>
              {content}
            </div>
            <div className='mt-8 flex justify-end gap-x-3'>
              <Button type='button' variant='outline' onClick={handleCancel} className='w-28 h-8'>
                Cancel
              </Button>
              <Button type='button' variant='secondary' onClick={handleConfirm} className='w-28 h-8'>
                Yes
              </Button>
            </div>
          </DialogPanel>
        </div>
      </div >
    </Dialog >
  )
}